/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_error__404__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `zurück zur Startseite`
};

const en_error__404__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `return to the homepage`
};

const es_error__404__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `volver a la página de inicio`
};

const fr_error__404__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `retourner à la page d’accueil`
};

const it_error__404__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `tornare alla home page`
};

const nl_error__404__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `terugkeren naar de startpagina`
};

const pt_error__404__back_home = /** @type {(inputs: {}) => string} */ () => {
	return `voltar à página inicial`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const error__404__back_home = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.error__404__back_home(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("error__404__back_home", locale)
	if (locale === "de") return de_error__404__back_home(inputs)
	if (locale === "en") return en_error__404__back_home(inputs)
	if (locale === "es") return es_error__404__back_home(inputs)
	if (locale === "fr") return fr_error__404__back_home(inputs)
	if (locale === "it") return it_error__404__back_home(inputs)
	if (locale === "nl") return nl_error__404__back_home(inputs)
	return pt_error__404__back_home(inputs)
};